var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 130,
  height: 90,
  fill: "none",
  viewBox: "0 0 326 120"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__b)",
  d: "M74.202 48.963c3.844-3.678-1.337-.669-1.337-.669-5.015 2.842-9.193 9.695-2.675 16.38 0 0-4.847-7.521 4.012-15.711"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__c)",
  d: "M70.859 41.107c2.507-2.34-.836-.836-.836-.836-21.729 8.859-2.34 58-.334 64.853.334 1.337 3.51 1.671 8.023 1.671.167 0-3.009-6.184-2.675-6.184.836 0 5.015 6.017 6.52 6.017 8.022.836 9.527-.167 9.527-.167 0-.501-6.52-5.014-6.686-5.683s14.542 9.36 7.689 2.674c-.502-.501-45.464-44.46-21.228-62.345"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__d)",
  d: "M58.657 45.787c1.672-5.181 6.018-8.859 11.2-9.862 2.005-.501 3.008-2.172-.837-1.504-3.677.669-7.187 2.173-10.363 4.346 0 0-1.003-.669 1.672-9.193.835-2.507-5.683-1.505-9.695 5.85l-.501 1.003c6.184 26.576 4.179 52.15.668 66.524-.501 2.006-1.17 3.176.669 3.677 0 0 .501.335.669 0 1.002-1.337 2.841-7.02 2.841-5.85-.167 6.352-3.343 8.19 8.19 5.516 0 0 1.839-.334 2.34-.501.335 0 .669-.168 1.003-.335.167.167-13.037-44.628-7.856-59.671"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__e)",
  d: "m46.79 39.77.668 1.17s10.865 17.717.168 62.847c0 0-.168 2.006-6.52 2.507 0 0-.334 0 0-1.003 0 0 1.672-5.349 1.004-5.181-.669.167-4.513 6.184-5.015 6.351-2.173.334-4.513.167-6.685-.334 0 0-.335 0 0-.836.334-.836 2.005-4.011 1.17-4.011-.836 0-5.683 4.178-6.352 4.178s-4.346-1.003-3.176-2.005c0 0 21.06-16.38 25.24-31.591 3.51-13.038-2.508-17.55-4.347-22.398-1.838-4.847 3.845-9.694 3.845-9.694"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__f)",
  d: "M40.104 52.473c-3.844 7.521 7.02 15.712 5.349 16.715 6.017-3.678-5.182-16.715-5.349-16.715"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__g)",
  d: "M102.45 53.81c17.216-10.029 9.527-33.43-10.698-27.914C96.432 14.865 80.22 4 70.358 15.032l-.836 1.003c1.671-19.39-20.894-20.726-19.556 0h-.335C41.943 4 22.888 13.026 29.24 26.398h.167-.168C16.871 22.721.323 36.427 16.035 52.808c.167.166-1.003 0-1.337 0-28.582 3.51-9.193 54.99 27.579 22.23 4.68-4.18 3.008-4.346-.836-2.006-30.922 18.553-47.637-18.22-8.524-15.21 2.674.167 2.34-1.672.167-2.173-28.08-7.856-17.216-33.931 3.008-19.89 1.84 1.336 1.672-.168 1.672-.335C22.72 13.026 45.285 9.349 50.968 23.222c1.003 2.507 1.84 2.173 1.672 1.003C49.464-2.518 70.859 1.66 66.179 22.387c-.669 2.841-.335 3.51.668 2.34C82.894 4 94.761 22.887 83.73 34.755c-.501.669-.835 2.675 1.505 1.17 23.4-14.207 28.916 10.698 4.513 18.386-3.176 1.003-2.508 2.34-.335 2.173 20.392-1.504 23.066 15.044 11.366 19.724-6.853 2.841-20.057-.836-27.245-8.19-1.337-1.338-2.005-1.003-1.671.167C74.87 76.208 87.74 86.236 95.93 86.236c27.579 0 29.752-28.415 6.519-32.426"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M134.374 67.015c.335.501.836 1.002 1.338 1.504q1.002.752 2.005 1.003c.836.334 1.672.501 2.508.334.835 0 1.838-.167 2.507-.501.668-.335 1.337-.836 2.005-1.338.502-.501 1.003-1.17 1.171-2.005a6.7 6.7 0 0 0 .501-2.508c0-1.17-.334-2.34-1.003-3.175a7.4 7.4 0 0 0-2.507-2.006c-1.003-.502-2.173-1.003-3.343-1.504s-2.173-1.003-3.176-1.672a9 9 0 0 1-2.507-2.507c-.669-1.17-1.17-2.674-1.003-4.012 0-1.17.167-2.34.669-3.343.334-1.002 1.003-1.838 1.838-2.674.836-.668 1.839-1.337 3.009-1.671 1.337-.502 2.507-.669 3.844-.669q1.755 0 3.51.502c1.003.334 2.006.835 2.842 1.504-.334.501-.502 1.003-.669 1.504l-.501 2.006h-.502c-.167-.334-.334-.836-.501-1.337-.334-.502-.669-1.003-1.003-1.337-.501-.335-1.003-.836-1.504-1.003-.669-.335-1.337-.335-2.006-.335-.836 0-1.504.168-2.173.335-.668.334-1.337.668-1.839 1.17-.501.501-.835 1.003-1.17 1.671s-.334 1.337-.334 2.173c0 1.17.334 2.34 1.003 3.176a7.4 7.4 0 0 0 2.507 2.006c1.003.501 2.173 1.003 3.343 1.337s2.34.836 3.343 1.504c1.003.669 1.839 1.337 2.507 2.34a7.76 7.76 0 0 1 1.003 3.845c0 1.337-.167 2.507-.668 3.844q-.752 1.755-2.006 3.009c-1.003.835-2.173 1.671-3.343 2.005-1.504.502-3.009.669-4.513.669s-3.009-.167-4.346-.669c-1.003-.501-2.006-1.002-2.841-1.671.167-.502.501-1.17.501-1.839.167-.501.167-1.17.334-2.006h.502q.25.752 1.003 1.505"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M134.374 67.015c.335.501.836 1.002 1.338 1.504q1.002.752 2.005 1.003c.836.334 1.672.501 2.508.334.835 0 1.838-.167 2.507-.501.668-.335 1.337-.836 2.005-1.338.502-.501 1.003-1.17 1.171-2.005a6.7 6.7 0 0 0 .501-2.508c0-1.17-.334-2.34-1.003-3.175a7.4 7.4 0 0 0-2.507-2.006c-1.003-.502-2.173-1.003-3.343-1.504s-2.173-1.003-3.176-1.672a9 9 0 0 1-2.507-2.507c-.669-1.17-1.17-2.674-1.003-4.012 0-1.17.167-2.34.669-3.343.334-1.002 1.003-1.838 1.838-2.674.836-.668 1.839-1.337 3.009-1.671 1.337-.502 2.507-.669 3.844-.669q1.755 0 3.51.502c1.003.334 2.006.835 2.842 1.504-.334.501-.502 1.003-.669 1.504l-.501 2.006h-.502c-.167-.334-.334-.836-.501-1.337-.334-.502-.669-1.003-1.003-1.337-.501-.335-1.003-.836-1.504-1.003-.669-.335-1.337-.335-2.006-.335-.836 0-1.504.168-2.173.335-.668.334-1.337.668-1.839 1.17-.501.501-.835 1.003-1.17 1.671s-.334 1.337-.334 2.173c0 1.17.334 2.34 1.003 3.176a7.4 7.4 0 0 0 2.507 2.006c1.003.501 2.173 1.003 3.343 1.337s2.34.836 3.343 1.504c1.003.669 1.839 1.337 2.507 2.34a7.76 7.76 0 0 1 1.003 3.845c0 1.337-.167 2.507-.668 3.844q-.752 1.755-2.006 3.009c-1.003.835-2.173 1.671-3.343 2.005-1.504.502-3.009.669-4.513.669s-3.009-.167-4.346-.669c-1.003-.501-2.006-1.002-2.841-1.671.167-.502.501-1.17.501-1.839.167-.501.167-1.17.334-2.006h.502c0 1.338.334 1.84.668 2.34Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M155.101 60.663V50.467c.668.167 1.17.167 1.838.167s1.17-.167 1.839-.167c-.167 1.672-.167 3.677-.334 5.683-.168 2.006-.168 4.179-.168 6.352 0 1.17.168 2.34.335 3.51.167.668.501 1.337 1.003 1.838s1.002.836 1.504 1.17c.668.335 1.504.502 2.173.502 1.003 0 2.173-.167 3.008-.836.836-.501 1.338-1.17 1.839-2.006.167-.501.334-.835.501-1.337.168-.501.168-.836.335-1.337 0-.502.167-1.337.167-2.34V50.634l1.003.167h2.006l.835-.167c-.167 2.173-.334 4.346-.334 6.519v10.53c0 1.17 0 2.507.167 3.51h-3.343v-3.51a7.08 7.08 0 0 1-2.841 3.009 7.76 7.76 0 0 1-3.845 1.003c-2.005.167-4.011-.502-5.516-1.672-1.337-1.337-2.005-3.175-2.005-5.181-.167-1.672-.167-3.009-.167-4.179"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M155.101 60.663V50.467c.668.167 1.17.167 1.838.167s1.17-.167 1.839-.167c-.167 1.672-.167 3.677-.334 5.683-.168 2.006-.168 4.179-.168 6.352 0 1.17.168 2.34.335 3.51.167.668.501 1.337 1.003 1.838s1.002.836 1.504 1.17c.668.335 1.504.502 2.173.502 1.003 0 2.173-.167 3.008-.836.836-.501 1.338-1.17 1.839-2.006.167-.501.334-.835.501-1.337.168-.501.168-.836.335-1.337 0-.502.167-1.337.167-2.34V50.634l1.003.167h2.006l.835-.167c-.167 2.173-.334 4.346-.334 6.519v10.53c0 1.17 0 2.507.167 3.51h-3.343v-3.51a7.08 7.08 0 0 1-2.841 3.009 7.76 7.76 0 0 1-3.845 1.003c-2.005.167-4.011-.502-5.516-1.672-1.337-1.337-2.005-3.175-2.005-5.181-.167-1.672-.167-3.009-.167-4.179Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M191.873 54.144c-.836-1.17-2.006-1.671-3.51-1.671-1.671-.167-3.343.501-4.513 1.839-1.003 1.504-1.504 3.342-1.337 5.181v7.689c0 1.337.167 2.674.334 3.844-1.337-.167-2.674-.167-3.844 0 .167-1.17.167-2.507.334-3.844s0-2.842 0-4.012V54.48c0-1.505-.167-2.842-.334-4.012.669.167 1.337.167 2.006.167h.835l1.003-.167c0 1.17-.167 2.34-.167 3.51a7.73 7.73 0 0 1 2.842-2.841c1.17-.669 2.674-1.003 4.011-1.003.836 0 1.672.167 2.507.334s1.505.669 2.173 1.17c.669.669 1.337 1.337 1.672 2.34.501 1.17.668 2.507.668 3.677s0 2.508-.167 3.845 0 2.674 0 4.178v5.516h-3.677c0-1.504.167-3.008.167-4.68s.167-3.176.167-4.847v-2.674c.167-1.672-.334-3.51-1.17-4.848"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M191.873 54.144c-.836-1.17-2.006-1.671-3.51-1.671-1.671-.167-3.343.501-4.513 1.839-1.003 1.504-1.504 3.342-1.337 5.181v7.689c0 1.337.167 2.674.334 3.844-1.337-.167-2.674-.167-3.844 0 .167-1.17.167-2.507.334-3.844s0-2.842 0-4.012V54.48c0-1.505-.167-2.842-.334-4.012.669.167 1.337.167 2.006.167h.835l1.003-.167c0 1.17-.167 2.34-.167 3.51a7.73 7.73 0 0 1 2.842-2.841c1.17-.669 2.674-1.003 4.011-1.003.836 0 1.672.167 2.507.334s1.505.669 2.173 1.17c.669.669 1.337 1.337 1.672 2.34.501 1.17.668 2.507.668 3.677s0 2.508-.167 3.845 0 2.674 0 4.178v5.516h-3.677c0-1.504.167-3.008.167-4.68s.167-3.176.167-4.847v-2.674c.167-1.672-.167-3.51-1.17-4.848Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M216.109 54.144c-.835-1.17-2.173-1.671-3.51-1.671-1.671-.167-3.343.501-4.346 1.839-1.002 1.504-1.504 3.342-1.337 5.181v7.689c0 1.337.167 2.674.335 3.844-1.338-.167-2.675-.167-3.845 0 .167-1.17.167-2.507.335-3.844.167-1.337 0-2.842 0-4.012V54.48c0-1.505-.168-2.842-.335-4.012.669.167 1.337.167 2.006.167h.836l1.003-.167c-.168 1.17-.168 2.34-.168 3.51a7.73 7.73 0 0 1 2.842-2.841c1.17-.669 2.674-1.003 4.011-1.003.836 0 1.672.167 2.508.334.835.167 1.671.669 2.173 1.17.668.669 1.337 1.337 1.671 2.34.501 1.17.669 2.507.669 3.677s0 2.508-.168 3.845c-.167 1.337-.167 2.674-.167 4.178v5.516h-3.677c0-1.504.167-3.008.167-4.68s.167-3.176.167-4.847v-2.674c.168-1.672-.334-3.51-1.337-4.848"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M216.109 54.144c-.835-1.17-2.173-1.671-3.51-1.671-1.671-.167-3.343.501-4.346 1.839-1.002 1.504-1.504 3.342-1.337 5.181v7.689c0 1.337.167 2.674.335 3.844-1.338-.167-2.675-.167-3.845 0 .167-1.17.167-2.507.335-3.844.167-1.337 0-2.842 0-4.012V54.48c0-1.505-.168-2.842-.335-4.012.669.167 1.337.167 2.006.167h.836l1.003-.167c-.168 1.17-.168 2.34-.168 3.51a7.73 7.73 0 0 1 2.842-2.841c1.17-.669 2.674-1.003 4.011-1.003.836 0 1.672.167 2.508.334.835.167 1.671.669 2.173 1.17.668.669 1.337 1.337 1.671 2.34.501 1.17.669 2.507.669 3.677s0 2.508-.168 3.845c-.167 1.337-.167 2.674-.167 4.178v5.516h-3.677c0-1.504.167-3.008.167-4.68s.167-3.176.167-4.847v-2.674c0-1.672-.334-3.51-1.17-4.848Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M230.15 65.51c.334 1.003.835 1.839 1.337 2.675.501.668 1.17 1.17 1.838 1.337s1.338.334 2.173.334c1.003 0 2.006-.334 2.842-.836.835-.501 1.504-1.337 2.005-2.173.502-1.002 1.003-2.005 1.17-3.008.168-1.17.335-2.34.335-3.51.167-2.173-.502-4.513-1.672-6.352-1.17-1.504-2.841-2.34-4.68-2.173-1.003 0-1.838.167-2.674.669a7.1 7.1 0 0 0-1.839 2.006c-.501 1.002-.835 2.005-1.17 3.008-.334 1.17-.334 2.507-.334 3.677.167 1.672.334 3.01.669 4.346m11.7 1.505-1.003 1.504q-.501.752-1.504 1.504c-.669.502-1.338.836-2.006 1.17-1.003.335-2.006.502-2.842.335a9.7 9.7 0 0 1-3.175-.502c-1.003-.334-2.006-1.003-2.842-1.838-.836-1.003-1.504-2.173-2.006-3.344-.501-1.504-.835-3.175-.668-4.847 0-1.671.167-3.343.835-4.847.502-1.17 1.17-2.34 2.173-3.343q1.254-1.253 3.009-2.006c1.003-.501 2.173-.668 3.343-.668 3.009-.167 5.683 1.504 6.686 4.346h.167V40.94c0-.836 0-1.672-.167-2.34l1.003.167h2.005l1.003-.167c0 .835-.167 2.173-.167 4.011s-.167 3.677-.167 5.85 0 4.179-.167 6.519 0 4.179 0 6.184v5.35c0 1.503 0 3.175.167 4.846h-3.343v-4.345z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M230.15 65.51c.334 1.003.835 1.839 1.337 2.675.501.668 1.17 1.17 1.838 1.337s1.338.334 2.173.334c1.003 0 2.006-.334 2.842-.836.835-.501 1.504-1.337 2.005-2.173.502-1.002 1.003-2.005 1.17-3.008.168-1.17.335-2.34.335-3.51.167-2.173-.502-4.513-1.672-6.352-1.17-1.504-2.841-2.34-4.68-2.173-1.003 0-1.838.167-2.674.669a7.1 7.1 0 0 0-1.839 2.006c-.501 1.002-.835 2.005-1.17 3.008-.334 1.17-.334 2.507-.334 3.677.167 1.505.334 3.01.669 4.346Zm11.7 1.505-1.003 1.504q-.501.752-1.504 1.504c-.669.502-1.338.836-2.006 1.17-.836.335-1.839.335-2.842.335a9.7 9.7 0 0 1-3.175-.502c-1.003-.334-2.006-1.003-2.842-1.838-.836-1.003-1.504-2.173-2.006-3.344-.501-1.504-.835-3.175-.668-4.847 0-1.671.167-3.343.835-4.847.502-1.17 1.17-2.34 2.173-3.343q1.254-1.253 3.009-2.006c1.003-.501 2.173-.668 3.343-.668 3.009-.167 5.683 1.504 6.686 4.346h.167V40.94c0-.836 0-1.672-.167-2.34l1.003.167h2.005l1.003-.167c0 .835-.167 2.173-.167 4.011s-.167 3.677-.167 5.85 0 4.179-.167 6.519 0 4.179 0 6.184v5.35c0 1.503 0 3.175.167 4.846h-3.343l.167-4.178z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "m260.737 60.83-2.006.334-2.005.502c-.669.167-1.17.501-1.672.836-.501.334-.836.835-1.17 1.337q-.501 1.002-.501 2.006c0 1.17.334 2.34 1.17 3.008.668.669 1.671 1.003 2.674 1.003s2.173-.334 3.009-.836c.835-.501 1.504-1.337 2.005-2.172l.168-6.52c-.502.168-1.003.335-1.672.502m-5.349-10.196c1.003-.334 2.173-.501 3.343-.501 1.003 0 2.006.167 2.842.501s1.504.669 2.173 1.337q1.003.753 1.504 2.006c.334.836.501 1.672.501 2.675v4.847c0 1.504-.167 3.343-.167 5.181v1.17c0 .335 0 .669.167 1.003.168.335.335.502.502.836.334.167.669.334 1.003.334h.501c.167 0 .335 0 .502-.167v1.003c-.335.167-.836.334-1.17.334-.502.167-1.17.167-1.672.167-1.504.168-2.841-.835-3.008-2.34v-.167c-.836 1.003-2.006 1.672-3.009 2.34-1.17.502-2.507.836-3.677.669-.669 0-1.505-.167-2.173-.334-.669-.168-1.337-.502-1.839-1.003-.501-.502-1.003-1.003-1.337-1.672-.334-.668-.501-1.504-.501-2.173 0-1.504.501-3.008 1.671-4.011 1.337-1.003 2.842-1.672 4.513-1.839 1.504-.334 2.841-.501 3.677-.668l2.006-.502c.334-.167.669-.334.836-.668.167-.335.167-.669.167-1.003 0-.669 0-1.337-.167-2.006s-.502-1.17-.836-1.671-.836-.836-1.504-1.17c-.669-.335-1.505-.502-2.173-.502-1.17 0-2.173.334-3.176.836-1.003.501-1.671 1.17-2.173 2.173h-1.003v-2.34c1.17-1.505 2.34-2.173 3.677-2.675"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "m260.737 60.83-2.006.334-2.005.502c-.669.167-1.17.501-1.672.836-.501.334-.835.835-1.17 1.337q-.501 1.002-.501 2.006c0 1.17.334 2.34 1.17 3.008.668.669 1.671 1.003 2.674 1.003s2.173-.334 3.009-.836c.836-.501 1.504-1.337 2.006-2.172l.167-6.52c-.502.168-1.17.335-1.672.502Zm-5.516-10.196c1.003-.334 2.173-.501 3.343-.501 1.003 0 2.006.167 2.842.501s1.504.669 2.173 1.337q1.002.753 1.504 2.006c.334.836.501 1.672.501 2.675v4.847c0 1.504-.167 3.343-.167 5.181v1.17c0 .335 0 .669.167 1.003.168.335.335.502.502.836.334.167.668.334 1.003.334h.501c.167 0 .335 0 .502-.167v1.003c-.335.167-.836.334-1.17.334-.502.167-1.17.167-1.672.167-1.504.168-2.841-.835-3.008-2.34v-.167c-.836 1.003-2.006 1.672-3.009 2.34-1.17.502-2.507.836-3.677.669-.669 0-1.505-.167-2.173-.334-.669-.168-1.337-.502-1.839-1.003-.501-.502-1.003-1.003-1.337-1.672-.334-.668-.501-1.504-.501-2.173 0-1.504.501-3.008 1.671-4.011 1.337-1.003 2.842-1.672 4.513-1.839 1.504-.334 2.841-.501 3.677-.668l2.006-.502c.334-.167.669-.334.836-.668.167-.335.167-.669.167-1.003 0-.669 0-1.337-.167-2.006s-.502-1.17-.836-1.671-.836-.836-1.504-1.17c-.669-.335-1.505-.502-2.173-.502-1.17 0-2.173.334-3.176.836-1.003.501-1.672 1.17-2.173 2.173h-.836v-2.34c1.003-1.505 2.34-2.173 3.51-2.675Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M273.942 47.793V44.45c0-1.003 0-2.173-.167-3.176-.168-1.003-.168-1.839-.168-2.674a8.15 8.15 0 0 0 4.012 0c0 .668-.167 1.671-.167 2.674s-.167 2.173-.167 3.176v20.893c0 1.003 0 2.173.167 3.176s.167 1.838.167 2.507h-4.012c0-.668.168-1.504.168-2.507s0-2.006.167-3.176v-17.55"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M273.942 47.793V44.45c0-1.003 0-2.173-.167-3.176-.168-1.003-.168-1.839-.168-2.674a8.15 8.15 0 0 0 4.012 0c0 .668-.167 1.671-.167 2.674s-.167 2.173-.167 3.176v20.893c0 1.003 0 2.173.167 3.176s.167 1.838.167 2.507h-4.012c0-.668.168-1.504.168-2.507s0-2.006.167-3.176v-17.55Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M134.374 104.455c.335.502.836 1.003 1.338 1.505q1.002.751 2.005 1.003c.836.334 1.672.501 2.508.334.835 0 1.838-.167 2.507-.502 1.504-.668 2.674-1.838 3.176-3.343a6.7 6.7 0 0 0 .501-2.507c0-1.17-.334-2.34-1.003-3.175a7.4 7.4 0 0 0-2.507-2.006c-1.003-.502-2.173-1.003-3.343-1.337-1.17-.502-2.173-1.003-3.176-1.672a9 9 0 0 1-2.507-2.507c-.669-1.17-1.17-2.674-1.003-4.012 0-1.17.167-2.34.669-3.343.334-1.002 1.003-1.838 1.838-2.507.836-.668 1.839-1.337 3.009-1.671a16.5 16.5 0 0 1 4.011-.502q1.755 0 3.511.502c1.002.334 2.005.836 2.841 1.504-.334.502-.501 1.003-.669 1.505l-.501 2.005h-.501c-.168-.501-.335-.835-.502-1.337-.334-.501-.668-1.003-1.003-1.337q-.752-.753-1.504-1.003c-.669-.334-1.337-.502-2.006-.334-.836 0-1.504.167-2.173.334-.668.167-1.337.669-1.838 1.17-.502.502-.836 1.003-1.17 1.672-.335.668-.335 1.504-.335 2.172 0 1.17.335 2.34 1.003 3.176a7.4 7.4 0 0 0 2.507 2.006c1.003.501 2.173 1.003 3.343 1.504 1.17.335 2.34.836 3.343 1.505s1.839 1.337 2.507 2.34a7.76 7.76 0 0 1 1.003 3.844c0 1.337-.167 2.507-.668 3.677-.502 1.17-1.17 2.173-2.006 3.176-1.003.836-2.173 1.671-3.343 2.006-1.504.501-3.009.668-4.513.668s-3.009-.167-4.513-.668c-1.003-.502-2.006-1.003-2.841-1.672.167-.501.501-1.17.501-1.671.167-.502.167-1.17.334-2.006h.502c0 .501.334 1.003.668 1.504"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M134.374 104.455c.335.502.836 1.003 1.338 1.505q1.002.751 2.005 1.003c.836.334 1.672.501 2.508.334.835 0 1.838-.167 2.507-.502 1.504-.668 2.674-1.838 3.176-3.343a6.7 6.7 0 0 0 .501-2.507c0-1.17-.334-2.34-1.003-3.175a7.4 7.4 0 0 0-2.507-2.006c-1.003-.502-2.173-1.003-3.343-1.337-1.17-.502-2.173-1.003-3.176-1.672a9 9 0 0 1-2.507-2.507c-.669-1.17-1.17-2.674-1.003-4.012 0-1.17.167-2.34.669-3.343.334-1.002 1.003-1.838 1.838-2.507.836-.668 1.839-1.337 3.009-1.671a16.5 16.5 0 0 1 4.011-.502q1.755 0 3.511.502c1.002.334 2.005.836 2.841 1.504-.334.502-.501 1.003-.669 1.505l-.501 2.005h-.501c-.168-.501-.335-.835-.502-1.337-.334-.501-.668-1.003-1.003-1.337q-.752-.753-1.504-1.003c-.669-.334-1.337-.502-2.006-.334-.836 0-1.504.167-2.173.334-.668.167-1.337.669-1.838 1.17-.502.502-.836 1.003-1.17 1.672-.335.668-.335 1.504-.335 2.172 0 1.17.335 2.34 1.003 3.176a7.4 7.4 0 0 0 2.507 2.006c1.003.501 2.173 1.003 3.343 1.504 1.17.335 2.34.836 3.343 1.505s1.839 1.337 2.507 2.34a7.76 7.76 0 0 1 1.003 3.844c0 1.337-.167 2.507-.668 3.677-.502 1.17-1.17 2.173-2.006 3.176-1.003.836-2.173 1.671-3.343 2.006-1.504.501-3.009.668-4.513.668s-3.009-.167-4.513-.668c-1.003-.502-2.006-1.003-2.841-1.672.167-.501.501-1.17.501-1.671.167-.502.167-1.17.334-2.006h.502c0 .501.334 1.003.668 1.504Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M169.643 93.758c-.335-1.003-.836-1.839-1.338-2.674-.501-.669-1.17-1.17-2.005-1.338-.669-.167-1.337-.334-2.173-.334-1.003 0-2.006.167-3.009.669a5.76 5.76 0 0 0-2.006 2.006c-.501.835-1.002 1.838-1.17 2.841-.167 1.17-.334 2.34-.334 3.51 0 6.017 2.173 9.026 6.352 9.026 1.003 0 1.838-.167 2.674-.669.836-.501 1.504-1.17 1.839-2.005.501-1.003.835-2.006 1.17-3.009.334-1.17.334-2.34.334-3.677.167-1.504 0-3.009-.334-4.346m-15.044 3.51v-3.51c0-1.17 0-2.173-.167-3.343s0-2.006-.167-2.674c1.337.334 2.674.334 3.845 0-.168.668-.168 1.504-.335 2.173-.167.668-.167 1.337-.167 2.005h.167c.167-.501.502-1.002.836-1.504q.502-.752 1.504-1.504c.669-.502 1.337-.836 2.173-1.17.836-.335 1.839-.502 2.842-.502 1.17 0 2.173.167 3.175.669 1.003.501 2.006 1.003 2.842 2.006s1.504 2.173 2.006 3.343c.501 1.504.835 3.175.668 4.847 0 1.671-.167 3.343-.835 4.847-.502 1.17-1.17 2.34-2.173 3.343q-1.254 1.254-3.009 2.006c-1.003.334-2.173.668-3.343.668-2.841.168-5.516-1.504-6.853-4.011h-.167v9.026c0 1.17 0 2.173.167 3.176.167 1.002.502 1.838.502 2.507-1.338-.335-2.675-.335-3.845 0 0-.669.167-1.672.167-2.675s0-2.173.167-3.175c.168-1.003 0-2.173 0-3.343V97.268"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M169.643 93.758c-.335-1.003-.836-1.839-1.338-2.674-.501-.669-1.17-1.17-2.005-1.338-.669-.167-1.337-.334-2.173-.334-1.003 0-2.006.167-3.009.669a5.76 5.76 0 0 0-2.006 2.006c-.501.835-1.002 1.838-1.17 2.841-.167 1.17-.334 2.34-.334 3.51 0 6.017 2.173 9.026 6.352 9.026 1.003 0 1.838-.167 2.674-.669.836-.501 1.504-1.17 1.839-2.005.501-1.003.835-2.006 1.17-3.009.334-1.17.334-2.34.334-3.677.167-1.504 0-3.009-.334-4.346Zm-15.044 3.51v-3.51c0-1.17 0-2.173-.167-3.343s0-2.006-.167-2.674c1.337.334 2.674.334 3.845 0-.168.668-.168 1.504-.335 2.173-.167.668-.167 1.337-.167 2.005h.167c.167-.501.502-1.002.836-1.504q.502-.752 1.504-1.504c.669-.502 1.337-.836 2.173-1.17.836-.335 1.839-.502 2.842-.502 1.17 0 2.173.167 3.175.669 1.003.501 2.006 1.003 2.842 2.006s1.504 2.173 2.006 3.343c.501 1.504.835 3.175.668 4.847 0 1.671-.167 3.343-.835 4.847-.502 1.17-1.17 2.34-2.173 3.343q-1.254 1.254-3.009 2.006c-1.003.334-2.173.668-3.343.668-2.841.168-5.516-1.504-6.853-4.011h-.167v9.026c0 1.17 0 2.173.167 3.176.167 1.002.502 1.838.502 2.507-1.338-.335-2.675-.335-3.845 0 0-.669.167-1.672.167-2.675s0-2.173.167-3.175c.168-1.003 0-2.173 0-3.343V97.268Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "m188.53 98.104-2.006.334-2.005.501c-.669.168-1.17.502-1.672.836-.501.335-.836.836-1.17 1.337-.836 1.672-.501 3.678.669 5.015.668.668 1.671 1.003 2.674 1.003s2.173-.335 3.009-.836 1.504-1.337 2.005-2.173l.168-6.519c-.502.167-1.003.335-1.672.502m-5.349-10.196c1.003-.334 2.173-.502 3.343-.502 1.003 0 2.006.168 2.842.502s1.504.668 2.173 1.337c.668.501 1.17 1.337 1.504 2.006.334.835.501 1.671.501 2.674 0 1.672 0 3.343-.167 4.847s0 3.343 0 5.182v1.17c0 .334 0 .669.167 1.003.168.334.335.501.502.668.334.168.668.335 1.003.335h.501c.167 0 .334 0 .502-.167v1.002c-.335.168-.836.335-1.17.335-.502.167-1.17.167-1.672.167-.836 0-1.504-.167-2.173-.669-.501-.501-.835-1.17-.835-1.838-.836 1.003-2.006 1.671-3.009 2.34-1.17.501-2.507.835-3.677.668-.669 0-1.505-.167-2.173-.334s-1.337-.501-1.839-1.003c-.501-.501-1.003-1.003-1.337-1.671s-.501-1.505-.501-2.173c0-1.505.501-3.009 1.671-4.012 1.337-1.003 2.841-1.671 4.513-1.838 1.504-.335 2.841-.502 3.677-.669.669-.167 1.17-.334 1.839-.501.334-.167.668-.335.668-.669.168-.334.168-.668.168-1.003 0-.668-.168-1.337-.335-2.006s-.501-1.17-.836-1.671-.835-.836-1.504-1.17c-.668-.334-1.504-.502-2.173-.502-1.17 0-2.173.335-3.176.836-1.002.502-1.671 1.17-2.172 2.173h-.502v-2.34c1.17-1.337 2.34-2.006 3.677-2.507"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "m188.53 98.104-2.006.334-2.005.501c-.669.168-1.17.502-1.672.836-.501.335-.836.836-1.17 1.337-.836 1.672-.501 3.678.669 5.015.668.668 1.671 1.003 2.674 1.003s2.173-.335 3.009-.836 1.504-1.337 2.005-2.173l.168-6.519c-.502.167-1.171.335-1.672.502Zm-5.349-10.196c1.003-.334 2.173-.502 3.343-.502 1.003 0 2.006.168 2.842.502s1.504.668 2.173 1.337c.668.501 1.17 1.337 1.504 2.006.334.835.501 1.671.501 2.674 0 1.672 0 3.343-.167 4.847s0 3.343 0 5.182v1.17c0 .334 0 .669.167 1.003.168.334.335.501.502.668.334.168.668.335 1.003.335h.501c.167 0 .334 0 .502-.167v1.002c-.335.168-.836.335-1.17.335-.502.167-1.17.167-1.672.167-.836 0-1.504-.167-2.173-.669-.501-.501-.835-1.17-.835-1.838-.836 1.003-2.006 1.671-3.009 2.34-1.17.501-2.507.835-3.677.668-.669 0-1.505-.167-2.173-.334s-1.337-.501-1.839-1.003c-.501-.501-1.003-1.003-1.337-1.671s-.501-1.505-.501-2.173c0-1.505.501-3.009 1.671-4.012 1.337-1.003 2.841-1.671 4.513-1.838 1.504-.335 2.841-.502 3.677-.669l2.006-.501c.334-.167.669-.335.669-.669.167-.334.167-.668.167-1.003 0-.668-.167-1.337-.335-2.006-.167-.668-.501-1.17-.835-1.671-.335-.502-.836-.836-1.505-1.17s-1.504-.502-2.173-.502c-1.17 0-2.172.335-3.175.836-1.003.502-1.672 1.17-2.173 2.173h-.502v-2.34c1.003-1.337 2.173-2.006 3.51-2.507Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M209.758 90.917c-.334-.168-.836-.168-1.337-.168-.669 0-1.338.168-1.839.502s-1.003.668-1.337 1.337c-.334.501-.669 1.17-.836 1.839-.167.835-.334 1.504-.334 2.34v9.36c0 .836 0 1.671.167 2.507-.501 0-1.17-.167-1.671-.167-.669 0-1.17 0-1.839.167.167-1.003.167-2.34.167-4.011V93.257c0-1.505 0-3.176-.167-5.015l.836.167h1.838l.836-.167c-.167 1.003-.167 1.839-.167 2.507v1.672h.167c1.671-3.176 3.51-4.68 5.683-4.68h.669c.167 0 .501.167.668.167-.167.501-.334 1.17-.167 1.671v2.006l-.334.167c-.167-.501-.502-.668-1.003-.835"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M209.758 90.917c-.334-.168-.836-.168-1.337-.168-.669 0-1.338.168-1.839.502s-1.003.668-1.337 1.337c-.334.501-.669 1.17-.836 1.839-.167.835-.334 1.504-.334 2.34v9.36c0 .836 0 1.671.167 2.507-.501 0-1.17-.167-1.671-.167-.669 0-1.17 0-1.839.167.167-1.003.167-2.34.167-4.011V93.257c0-1.505 0-3.176-.167-5.015l.836.167h1.838l.836-.167c-.167 1.003-.167 1.839-.167 2.507v1.672h.167c1.671-3.176 3.51-4.68 5.683-4.68h.669c.167 0 .501.167.668.167-.167.501-.334 1.17-.167 1.671v2.006l-.334.167c-.335-.501-.669-.668-1.003-.835Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M220.622 89.58a9.6 9.6 0 0 0-1.839 1.838c-.501.669-.835 1.504-1.002 2.34l-.502 2.507 2.842.167h5.683l2.841-.167c0-.835 0-1.671-.167-2.507s-.334-1.671-.836-2.34c-.334-.669-1.003-1.337-1.671-1.839-.836-.501-1.839-.835-2.675-.668-1.003 0-1.838.167-2.674.668m-4.847.835c1.838-2.173 4.513-3.176 7.354-3.009 1.337 0 2.675.168 4.012.669 1.003.501 2.005 1.003 2.841 1.839.669.835 1.337 1.671 1.672 2.841.334 1.003.501 2.173.501 3.343v1.671l-4.68-.167h-7.522l-2.841.167v1.17c0 1.003.167 2.173.501 3.176q.502 1.504 1.505 2.508c.668.668 1.504 1.337 2.34 1.671 1.003.501 2.173.669 3.176.669.668 0 1.17 0 1.838-.168a8.2 8.2 0 0 0 1.839-.668c.668-.334 1.17-.669 1.671-1.003s1.003-.836 1.337-1.17l.168.167-.335 2.173c-1.003.669-2.006 1.337-3.176 1.839-1.337.501-2.674.668-4.011.668-1.504 0-2.842-.167-4.346-.668-1.17-.502-2.34-1.17-3.343-2.006s-1.671-2.006-2.173-3.176c-.501-1.337-.835-2.674-.835-4.011q0-4.764 2.507-8.525"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M220.622 89.58a9.6 9.6 0 0 0-1.838 1.838c-.502.669-.836 1.504-1.003 2.34l-.502 2.507 2.842.167h5.683l2.841-.167c0-.835 0-1.671-.167-2.507s-.334-1.671-.836-2.34c-.334-.669-1.002-1.337-1.671-1.839-.836-.501-1.839-.835-2.674-.668-1.003 0-1.839.167-2.675.668Zm-4.68.835c1.839-2.173 4.513-3.176 7.355-3.009 1.337 0 2.674.168 4.011.669 1.003.501 2.006 1.003 2.842 1.839.668.835 1.337 1.671 1.671 2.841.334 1.003.501 2.173.501 3.343v1.671l-4.68-.167h-7.521l-2.842.167v1.17c0 1.003.167 2.173.502 3.176q.502 1.504 1.504 2.508c.669.668 1.504 1.337 2.34 1.671 1.003.501 2.173.669 3.176.669.668 0 1.17 0 1.839-.168a8.2 8.2 0 0 0 1.838-.668c.669-.334 1.17-.669 1.672-1.003.501-.334 1.002-.836 1.337-1.17l.167.167-.334 2.173c-1.003.669-2.006 1.337-3.176 1.839-1.337.501-2.674.668-4.012.668-1.504 0-2.841-.167-4.345-.668-1.171-.502-2.341-1.17-3.343-2.006-1.003-.836-1.672-2.006-2.173-3.176-.502-1.337-.836-2.674-.836-4.011q-.25-4.764 2.507-8.525Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M251.377 93.925c-.334-1.003-.668-1.838-1.337-2.507-.501-.669-1.17-1.17-1.839-1.504-.668-.335-1.504-.502-2.173-.502-.835 0-1.838.167-2.507.502-.835.334-1.671 1.002-2.173 1.671q-1.002 1.254-1.504 3.009a20.8 20.8 0 0 0-.501 4.513c0 5.85 2.172 8.691 6.351 8.691.836 0 1.672-.167 2.507-.668a5.76 5.76 0 0 0 2.006-2.006c.669-1.003 1.003-2.006 1.337-3.176a17.8 17.8 0 0 0 .502-4.178c-.167-1.338-.335-2.508-.669-3.845m3.51 8.357c-.501 1.338-1.17 2.508-2.173 3.511-.835 1.002-1.838 1.838-3.175 2.34-1.171.501-2.508.835-3.845.835s-2.507-.334-3.677-.835c-1.003-.502-1.839-1.17-2.507-2.173-1.003.835-2.006 1.671-2.842 2.507h-.835c0-.669 0-1.504.167-2.507 0-1.003 0-2.006.167-3.176s0-2.173 0-3.343V81.723c0-1.002 0-2.172-.167-3.175s-.167-1.839-.167-2.675c.668.167 1.337.167 2.005.167h1.003l1.17-.167c-.167.502-.167 1.505-.167 2.675s-.167 2.674-.167 4.178 0 3.176-.167 4.68c-.167 1.505 0 3.176-.167 4.513h.167c.835-1.337 2.006-2.507 3.176-3.343 1.17-.668 2.674-1.17 4.178-1.17 1.337 0 2.675.335 3.845.836 1.002.502 2.005 1.337 2.674 2.173a8.3 8.3 0 0 1 1.671 3.176 12.9 12.9 0 0 1-.167 8.691"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M251.377 93.925c-.334-1.003-.668-1.838-1.337-2.507-.501-.669-1.17-1.17-1.839-1.504-.668-.335-1.504-.502-2.173-.502-.835 0-1.838.167-2.507.502-.835.334-1.671 1.002-2.173 1.671q-1.002 1.254-1.504 3.009a20.8 20.8 0 0 0-.501 4.513c0 5.85 2.172 8.691 6.351 8.691.836 0 1.672-.167 2.507-.668a5.76 5.76 0 0 0 2.006-2.006c.669-1.003 1.003-2.006 1.337-3.176a17.8 17.8 0 0 0 .502-4.178c-.167-1.338-.335-2.675-.669-3.845Zm3.51 8.19c-.501 1.337-1.17 2.508-2.173 3.51-.835 1.003-1.838 1.839-3.175 2.34-1.171.502-2.508.836-3.845.836s-2.507-.334-3.677-.836c-1.003-.501-1.839-1.17-2.507-2.172-1.003.835-2.006 1.671-2.842 2.507h-.835c0-.669 0-1.505.167-2.507 0-1.003 0-2.006.167-3.176s0-2.173 0-3.343V81.556c0-1.003 0-2.173-.167-3.175-.167-1.003-.167-1.84-.167-2.675.668.167 1.337.167 2.005.167h1.003l1.17-.167c-.167.502-.167 1.504-.167 2.674s-.167 2.675-.167 4.18 0 3.175-.167 4.68 0 3.175-.167 4.512h.167c.835-1.337 2.006-2.507 3.176-3.343 1.17-.668 2.674-1.17 4.178-1.17 1.337 0 2.675.335 3.845.836 1.002.501 2.005 1.337 2.674 2.173a8.3 8.3 0 0 1 1.671 3.176c1.003 3.175.836 6.184-.167 8.691Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "m270.265 98.104-2.006.334-2.006.501c-.669.168-1.17.502-1.671.836-.502.335-.836.836-1.17 1.337q-.502 1.004-.502 2.006c0 1.17.334 2.34 1.17 3.009.669.668 1.672 1.003 2.675 1.003s2.172-.335 3.008-.836 1.504-1.337 2.006-2.173l.167-6.519c-.501.335-1.003.335-1.671.502m-5.349-10.196c1.003-.334 2.173-.502 3.343-.502 1.003 0 2.006.168 2.841.502s1.505.668 2.173 1.337c.669.501 1.17 1.337 1.505 2.006.334.835.501 1.671.501 2.674 0 1.672 0 3.343-.167 4.847s-.167 3.343-.167 5.182v1.17c0 .334 0 .669.167 1.003s.334.501.501.668c.335.168.669.335 1.003.335h.502c.167 0 .334 0 .501-.167v1.002c-.334.168-.836.335-1.17.335-.501.167-1.17.167-1.671.167-.836 0-1.505-.167-2.173-.669-.502-.501-.836-1.17-.836-1.838-.836 1.003-2.006 1.671-3.009 2.34-1.17.501-2.507.835-3.677.668-.669 0-1.504-.167-2.173-.334-.668-.167-1.337-.501-1.838-1.003s-1.003-1.003-1.338-1.671c-.334-.669-.501-1.505-.501-2.173 0-1.505.501-3.009 1.671-4.012 1.338-1.003 2.842-1.671 4.513-1.838 1.505-.335 2.842-.502 3.678-.669l2.005-.501c.335-.167.669-.335.836-.669s.167-.668.167-1.003c0-.668-.167-1.337-.334-2.006s-.502-1.17-.836-1.671-.836-.836-1.504-1.17c-.669-.334-1.504-.502-2.173-.502-1.17 0-2.173.335-3.176.836-1.003.502-1.671 1.17-2.173 2.173h-.501v-2.34c.836-1.337 2.173-2.006 3.51-2.507"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "m270.265 98.104-2.006.334-2.006.501c-.669.168-1.17.502-1.671.836-.502.335-.836.836-1.17 1.337q-.502 1.004-.502 2.006c0 1.17.334 2.34 1.17 3.009.669.668 1.672 1.003 2.675 1.003s2.172-.335 3.008-.836 1.504-1.337 2.006-2.173l.167-6.519c-.501.335-1.17.335-1.671.502Zm-5.349-10.196c1.003-.334 2.173-.502 3.343-.502 1.003 0 2.006.168 2.841.502s1.505.668 2.173 1.337c.669.501 1.17 1.337 1.505 2.006.334.835.501 1.671.501 2.674 0 1.672 0 3.343-.167 4.847s-.167 3.343-.167 5.182v1.17c0 .334 0 .669.167 1.003s.334.501.501.668c.335.168.669.335 1.003.335h.502c.167 0 .334 0 .501-.167v1.002c-.334.168-.836.335-1.17.335-.501.167-1.17.167-1.671.167-.836 0-1.505-.167-2.173-.669-.502-.501-.836-1.17-.836-1.838-.836 1.003-2.006 1.671-3.009 2.34-1.17.501-2.507.835-3.677.668-.669 0-1.504-.167-2.173-.334-.668-.167-1.337-.501-1.838-1.003s-1.003-1.003-1.338-1.671c-.334-.669-.501-1.505-.501-2.173 0-1.505.501-3.009 1.671-4.012 1.338-1.003 2.842-1.671 4.513-1.838 1.505-.335 2.842-.502 3.678-.669l2.005-.501c.335-.167.669-.335.836-.669s.167-.668.167-1.003c0-.668-.167-1.337-.334-2.006s-.502-1.17-.836-1.671-.836-.836-1.504-1.17c-.669-.334-1.504-.502-2.173-.502-1.17 0-2.173.335-3.176.836-1.003.502-1.671 1.17-2.173 2.173h-.501v-2.34c.836-1.337 2.173-2.006 3.51-2.507Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M295.337 91.418c-.836-1.17-2.173-1.672-3.51-1.672-1.672-.167-3.343.502-4.346 1.84-1.003 1.503-1.505 3.342-1.337 5.18v7.689c0 1.338.167 2.675.334 3.845-.669 0-1.337-.167-2.006-.167s-1.337 0-2.006.167c.167-1.17.167-2.507.335-3.845.167-1.337 0-2.841 0-4.011v-8.525c0-1.337-.168-2.841-.335-4.011.669.167 1.338.167 2.006.167h.836l1.003-.167c-.167 1.17-.167 2.34-.167 3.51h.167a7.7 7.7 0 0 1 2.841-2.842c1.17-.668 2.675-1.002 4.012-1.002.835 0 1.671.167 2.507.334s1.504.668 2.173 1.17c.668.668 1.337 1.337 1.671 2.34.502 1.17.669 2.507.669 3.677s0 2.507-.167 3.845c-.167 1.337-.167 2.674-.167 4.178v5.516c-.669 0-1.17-.167-1.839-.167s-1.17 0-1.839.167c0-1.504.167-3.009.167-4.68 0-1.672.168-3.176.168-4.847v-2.842c0-1.671-.335-3.51-1.17-4.847"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M295.337 91.418c-.836-1.17-2.173-1.672-3.51-1.672-1.672-.167-3.343.502-4.346 1.84-1.003 1.503-1.505 3.342-1.337 5.18v7.689c0 1.338.167 2.675.334 3.845-.669 0-1.337-.167-2.006-.167s-1.337 0-2.006.167c.167-1.17.167-2.507.335-3.845.167-1.337 0-2.841 0-4.011v-8.525c0-1.337-.168-2.841-.335-4.011.669.167 1.338.167 2.006.167h.836l1.003-.167c-.167 1.17-.167 2.34-.167 3.51h.167a7.7 7.7 0 0 1 2.841-2.842c1.17-.668 2.675-1.002 4.012-1.002.835 0 1.671.167 2.507.334s1.504.668 2.173 1.17c.668.668 1.337 1.337 1.671 2.34.502 1.17.669 2.507.669 3.677s0 2.507-.167 3.845c-.167 1.337-.167 2.674-.167 4.178v5.516c-.669 0-1.17-.167-1.839-.167s-1.17 0-1.839.167c0-1.504.167-3.009.167-4.68 0-1.672.168-3.176.168-4.847v-2.842c.167-1.671-.335-3.343-1.17-4.847Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#295135",
  d: "M306.87 85.066v-3.343c0-1.002 0-2.172-.167-3.175s0-1.839-.167-2.675a8.15 8.15 0 0 0 4.011 0c0 .669-.167 1.672-.167 2.675s-.167 2.005-.167 3.175v14.375c0 .502.167.836.501.836.335 0 .502-.167.836-.334l1.003-.67c.334-.166.668-.668 1.337-1.17.669-.5 1.337-1.336 2.006-2.005s1.504-1.504 2.34-2.507 1.504-1.672 2.173-2.507c.501.167 1.17.167 1.671.167h1.003l1.17-.167c-1.838 1.504-3.51 2.841-5.181 4.346s-3.176 2.841-4.68 4.345l5.014 6.018a89 89 0 0 0 5.349 5.85c-.502 0-.836-.167-1.338-.167h-2.172c-.335 0-.836 0-1.171.167-.668-.669-1.337-1.505-2.172-2.507l-2.34-2.842c-.836-1.003-1.505-1.839-2.34-2.674-.836-.836-1.338-1.505-1.839-2.006l-.334-.334-.335-.168q-.501 0-.501.502v2.674c0 1.337 0 2.508.167 3.845 0 1.17.167 2.507.334 3.677-.668 0-1.337-.167-2.005-.167-.669 0-1.338 0-2.006.167 0-.669.167-1.504.167-2.507s0-2.006.167-3.176 0-2.34 0-3.343V88.242c-.167-1.003-.167-2.173-.167-3.176"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#295135",
  strokeWidth: 0.34,
  d: "M306.87 85.066v-3.343c0-1.002 0-2.172-.167-3.175s0-1.839-.167-2.675a8.15 8.15 0 0 0 4.011 0c0 .669-.167 1.672-.167 2.675s-.167 2.005-.167 3.175v14.375c0 .502.167.836.501.836.335 0 .502-.167.836-.334l1.003-.67c.334-.166.668-.668 1.337-1.17.669-.5 1.337-1.336 2.006-2.005s1.504-1.504 2.34-2.507 1.504-1.672 2.173-2.507c.501.167 1.17.167 1.671.167h1.003l1.17-.167c-1.838 1.504-3.51 2.841-5.181 4.346s-3.176 2.841-4.68 4.345l5.014 6.018a89 89 0 0 0 5.349 5.85c-.502 0-.836-.167-1.338-.167h-2.172c-.335 0-.836 0-1.171.167-.668-.669-1.337-1.505-2.172-2.507l-2.34-2.842c-.836-1.003-1.505-1.839-2.34-2.674-.836-.836-1.338-1.505-1.839-2.006l-.334-.334-.335-.168q-.501 0-.501.502v2.674c0 1.337 0 2.508.167 3.845 0 1.17.167 2.507.334 3.677-.668 0-1.337-.167-2.005-.167-.669 0-1.338 0-2.006.167 0-.669.167-1.504.167-2.507s0-2.006.167-3.176 0-2.34 0-3.343V88.242c-.167-1.003-.167-2.006-.167-3.176Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__b",
  x1: 66.586,
  x2: 78.619,
  y1: 59.323,
  y2: 52.37,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D6DB3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#D6DB3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#D1D93B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#C6D43F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#B2CB45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#A8C443"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#9FBD44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#8DB44C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#89B14C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#85AE4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#80AB4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#7CA84C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#78A54B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#74A14A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#6E9E48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#6A9B49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#639547"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#5E9347"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#5A8F46"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#548B45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#4E8643"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#498241"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#468040"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#447F3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#427C3E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.73,
  stopColor: "#3F7A3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.77,
  stopColor: "#3C783D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#397639"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.88,
  stopColor: "#377435"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#2E712A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2C7028"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__c",
  x1: 58.695,
  x2: 88.575,
  y1: 86.395,
  y2: 69.149,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D6DB3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#D1D93B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#C8D53D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#BFD143"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#B4CC44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#A8C544"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#A4C144"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#9CBC46"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#97B949"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#91B64B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#8AB24C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#86AF4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#80AB4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#7CA84C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#7AA64C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#77A44B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#74A14A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#6F9F48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#6B9C49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#689A48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#659747"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.41,
  stopColor: "#5E9347"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#5B9046"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#578D46"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#548B45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#518844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#4D8542"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#488141"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#447F3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#427C3E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#3F7A3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#3C783D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#3B773A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  stopColor: "#397639"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#2E712A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2C7028"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__d",
  x1: 36.41,
  x2: 83.445,
  y1: 81.974,
  y2: 54.829,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D6DB3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#D6DB3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#CFD83B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#C8D53D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#C1D242"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.07,
  stopColor: "#B9CF44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.09,
  stopColor: "#B0C945"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.11,
  stopColor: "#A6C443"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#A0BF45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#9BBC47"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#94B74A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#8DB44C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.23,
  stopColor: "#84AD4E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#7DA94C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#79A54B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#74A14A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#6E9E48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#699A48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#639647"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#5E9347"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#5B9046"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#578D46"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#538945"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#4F8743"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#4C8542"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#488141"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#437E3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#407B3E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#3F7A3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#3C783D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#3B773A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#397639"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#2E712A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2C7028"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__e",
  x1: 14.531,
  x2: 60.919,
  y1: 90.935,
  y2: 64.148,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D6DB3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#D6DB3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#CFD83B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#C3D340"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#B6CD46"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#ABC544"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#A0BF45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#95B849"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.19,
  stopColor: "#8DB44C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.22,
  stopColor: "#85AE4D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#78A54B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#6C9C49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#659747"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#5A8E45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#518844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#4B8442"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#478141"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#447F3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#417B3E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#3F7B3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#3E793D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.81,
  stopColor: "#3C783D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#377435"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#2E712A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2C7028"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__f",
  x1: 41.16,
  x2: 45.142,
  y1: 61.854,
  y2: 59.562,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D6DB3A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.03,
  stopColor: "#D1D93B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.05,
  stopColor: "#C4D340"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#B7CE45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#ADC645"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#A4C244"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#9BBC47"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#91B64B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.21,
  stopColor: "#89B14C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.25,
  stopColor: "#80AB4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3,
  stopColor: "#76A34A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.36,
  stopColor: "#6A9B49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#609447"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#588E45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#4F8743"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#457F3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#3F7A3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#3B773A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#397639"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#2E712A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2C7028"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__g",
  x1: 7.852,
  x2: 107.275,
  y1: 84.318,
  y2: 26.92,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D3DA3B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#C4D340"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#B0C945"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#A8C443"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#A4C144"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2,
  stopColor: "#88B04D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#78A54B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#6D9D48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.37,
  stopColor: "#659747"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#5A8E45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#538945"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#4E8643"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#488141"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#437E3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#3F7A3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.82,
  stopColor: "#3B773A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.91,
  stopColor: "#397639"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#30722E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.93,
  stopColor: "#2D7029"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#2C7028"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h325.289v120H0z"
})))));
export default SvgLogo;